import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar, scrollToHash } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { AboutManifesto } from "@/components/AboutManifesto";
import { PortalDivider } from "@/components/PortalDivider";
import { WhatAreYouBuilding } from "@/components/WhatAreYouBuilding";
import { JourneyStrip } from "@/components/JourneyStrip";
import { PlotToKey } from "@/components/PlotToKey";
import { WhyOmsivo } from "@/components/WhyOmsivo";
import { ServicePillars } from "@/components/ServicePillars";
import { ExplodedView } from "@/components/ExplodedView";
import { ProcessTimeline } from "@/components/ProcessTimeline";
import { Packages } from "@/components/Packages";
import { PackageComparison } from "@/components/PackageComparison";
import { AppPromo } from "@/components/AppPromo";
import { Concepts } from "@/components/Concepts";
import { Gallery } from "@/components/Gallery";
import { Showcases, MaterialsSection } from "@/components/Showcase";
import { Turnkey } from "@/components/Turnkey";
import { PartnerTeaser } from "@/components/PartnerTeaser";
import { CustomerJourney } from "@/components/CustomerJourney";
import { Projects } from "@/components/Projects";
import { Transparency } from "@/components/Transparency";
import { Faq } from "@/components/Faq";
import { ContactSection } from "@/components/ContactSection";
import { FinalCTA } from "@/components/FinalCTA";
import { Footer } from "@/components/Footer";
import { FloatingCTA } from "@/components/FloatingCTA";
import ServiceDetail from "@/components/ServiceDetail";
import ConceptDetail from "@/components/ConceptDetail";
import Partner from "@/components/Partner";

const Home = () => {
    const location = useLocation();
    useEffect(() => {
        const target = location.state?.scrollTo || (location.hash || null);
        if (target) {
            const t = setTimeout(() => scrollToHash(target), 400);
            return () => clearTimeout(t);
        }
        window.scrollTo(0, 0);
        return undefined;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key]);

    return (
        <main>
            <Navbar />
            <Hero />
            <Marquee />
            <AboutManifesto />
            <PortalDivider label="STEP INTO THE BUILD" testid="portal-hero" />
            <WhatAreYouBuilding />
            <JourneyStrip />
            <PlotToKey />
            <WhyOmsivo />
            <Concepts />
            <ServicePillars />
            <Gallery />
            <ExplodedView />
            <ProcessTimeline />
            <Packages />
            <PackageComparison />
            <AppPromo />
            <Showcases />
            <Turnkey />
            <PartnerTeaser />
            <MaterialsSection />
            <CustomerJourney />
            <Projects />
            <Transparency />
            <Faq />
            <ContactSection />
            <PortalDivider label="YOUR KEY IS WAITING" testid="portal-final" />
            <FinalCTA />
            <Footer />
        </main>
    );
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ autoRaf: true, lerp: 0.09 });
        window.__lenis = lenis;
        return () => { lenis.destroy(); window.__lenis = null; };
    }, []);

    return (
        <div className="App overflow-x-clip">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/services/:slug" element={<ServiceDetail />} />
                    <Route path="/concepts/:slug" element={<ConceptDetail />} />
                    <Route path="/partner" element={<Partner />} />
                    <Route path="/materials" element={<Navigate to="/services/building-materials" replace />} />
                    <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
                <FloatingCTA />
                <Toaster position="top-center" richColors />
            </BrowserRouter>
        </div>
    );
}

export default App;
